<template>
  <div id="cardEnvironmentalRestrictionsChart"></div>
</template>

<script>
import Highcharts from "highcharts";
import Exporting from "highcharts/modules/exporting";
import Accessibility from "highcharts/modules/accessibility";
import { mapGetters } from 'vuex';

Accessibility(Highcharts);
Exporting(Highcharts);
export default {
  name: "CardEnvironmentalRestrictionsChart",
  props: {
    location: {
      required: true,
    },
  },
  async mounted() {
    await this.initialize();
  },
  computed: {
    ...mapGetters(['restrictionData']),
  },
  methods: {
    async initialize() {
      await this.dataSource();
    },

    async dataSource() {
      const dataRestriction = this.restrictionData;  // Update in 'IndicatorsCards'
      let dataSeries = [];
      if (!this.location) {
        for (const k of Object.keys(dataRestriction)) {
          for (const [key, value] of Object.entries(dataRestriction[k].percs)) {
            if (value && value > 0) {
              dataSeries.push(
                {
                  name: `${key.split('-')[0]}`,
                  y: value,
                },
              );
            }
          }
        }
      }
      else {
        const dataRestricoesAmbientais = await this.$store.getters.restricoesAmbientais; // Update in 'IndicatorsCards'
        for (const [key, value] of Object.entries(dataRestricoesAmbientais[0].percentual)) {
          if (value && value > 0) {
            dataSeries.push(
              {
                name: `${key}`,
                y: value,
              },
            );
          }
        }
        if (dataRestricoesAmbientais[0].semrestricoes && dataRestricoesAmbientais[0].semrestricoes > 0) {
          dataSeries.push(
            {
              name: 'S/R',
              y: dataRestricoesAmbientais[0].semrestricoes,
            },
          );
        }
      }

      let data = [
        {
          name: "Restrições Ambientais",
          colorByPoint: true,
          size: "75%",
          dataLabels: {
            color: "#FFF",
            distance: -30,
          },
          data: dataSeries
        },
      ];
      this.createChartEnvironmentalRestrictions(data);
    },

    createChartEnvironmentalRestrictions(data) {
      let chart = document.getElementById("cardEnvironmentalRestrictionsChart");
      if (data.length > 0) {
        this.chartNew(data);
        chart.style.visibility = "visible";
        chart.style.display = "block";
      } else {
        chart.style.visibility = "hidden";
        chart.style.display = "none";
      }
    },

    chartNew(series) {
      const colors = ["#8330FF", "#69DB82", "#CF4F57", "#2C8CB8"];
      Highcharts.chart("cardEnvironmentalRestrictionsChart", {
        chart: {
          backgroundColor: "transparent",
          type: "pie",
          height: 250,
        },
        title: { text: null },
        subtitle: { text: null },
        credits: { enabled: false },
        exporting: { enabled: false },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              inside: true,
              // format: "<b>{point.name}</b>",
              formatter: function () {
                const name = this.point.name;
                return this.y > 0
                  ? (name.length > 20 ? name.slice(0, 20) + "..." : name)
                  : null;
              },
            },
            borderWidth: 0,
          },
        },
        series: series,
        colors: colors,
        tooltip: {
          headerFormat: "",
          pointFormat: '<strong style="color:{point.color}">{point.name}</strong>: <b>{point.y:.2f}%</b><br/>',
        },
      });
    },

  },
};
</script>
